import dayjs from 'dayjs';
import {
  toParticipantsArray,
  toParticipantOption
} from '../../../../utils/reviewParticipants';

export const setRatingShowInfo = ({
  setSupervisionRating,
  reviewData,
  reviewActiveKey,
  form,
  questionnaireType
}) => {
  setSupervisionRating(reviewData.supervision);

  const receiverOptions = toParticipantsArray(reviewData.receiver.id).map(
    toParticipantOption
  );

  form.setFieldsValue({
    ...reviewData,
    date: dayjs(reviewData.date),
    questionnaire_type: questionnaireType,
    author: { id: toParticipantOption(reviewData.author.id) },
    receiver: {
      id:
        reviewActiveKey === 'received_reviews'
          ? receiverOptions
          : receiverOptions[0]
    }
  });
};
